/** @jsx jsx */

import { MouseEvent } from 'react';
import { BrandButton, Link, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import { MEDIA_MIN_TABLET } from './constants';

const Styles = {
  loginLink: css`
    color: inherit;
    text-decoration: none;
    transition: all 0.2s ease-in-out;
    white-space: nowrap;
  `,
  root: css`
    align-items: center;
    color: inherit;
    display: flex;
    justify-content: space-around;
    /* Prefer visibility to display to keep the header height. */
    ${[MEDIA_MIN_TABLET]} {
      justify-content: initial;
      gap: 16px;
    }
  `,
  signUpButton: css`
    display: none;
    ${[MEDIA_MIN_TABLET]} {
      display: inline-block;
    }
  `,
};

type Props = {
  onClickLogIn?: (event: MouseEvent) => void;
  onClickSignUp?: (event: MouseEvent) => void;
  urlLogIn: string;
  urlSignUp: string;
};

function AuthButtons({
  onClickLogIn,
  onClickSignUp,
  urlLogIn,
  urlSignUp,
}: Props) {
  return (
    <nav css={Styles.root}>
      <Link css={Styles.loginLink} href={urlLogIn} onClick={onClickLogIn}>
        <Text color="inherit" type="paragraph3">
          Log in
        </Text>
      </Link>
      <span css={Styles.signUpButton}>
        <BrandButton href={urlSignUp} onClick={onClickSignUp}>
          Sign up
        </BrandButton>
      </span>
    </nav>
  );
}

export default AuthButtons;
